import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
    import { subscriptionListing, subscriptionAddUpdate, subscriptionDetails, userSubscriptionDetails } from "../apis/apiHandler";

export const subscription = createAsyncThunk(
    "Subscription/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await subscriptionListing(payload);

            if (response?.code === 1 || response?.code === 2) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addUpdateSubscription = createAsyncThunk(
    "subscription/addUpdate",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await subscriptionAddUpdate(payload);

            if (response?.code === 1) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const getSubscriptionDetails = createAsyncThunk(
    "subscription/details",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await subscriptionDetails(payload);

            if (response?.code === 1) { 
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const getUserSubscriptionDetails = createAsyncThunk(
    "subscription/userDetails",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await userSubscriptionDetails(payload);

            if (response?.code === 1) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    subscriptionList: [],
    subscriptionDetails: {},
    userSubscriptionDetails: [],
    addUpdateSubscriptionData: {},
    error: null,
    success: false,
};

const subscriptionSlice = createSlice({
    name: "subscription",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(subscription.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(subscription.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.subscriptionList = payload;
                state.success = true;
            })
            .addCase(subscription.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addUpdateSubscription.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(addUpdateSubscription.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addUpdateSubscriptionData = payload;
                state.success = true;
            })
            .addCase(addUpdateSubscription.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(getSubscriptionDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(getSubscriptionDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.subscriptionDetails = payload;
                state.success = true;
            })
            .addCase(getSubscriptionDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(getUserSubscriptionDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(getUserSubscriptionDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.userSubscriptionDetails = payload;
                state.success = true;
            })
            .addCase(getUserSubscriptionDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            });
    },
});

export default subscriptionSlice.reducer;
